export const ADD_CONTACT_DIRECTORY = {
  HOSPITAL_NAME: "hospitalName",
  ADDRESS: "address",
  SPECIALTIES: "specialties",
  CONTACT_NUMBER: "contactNumber",
  EMAIL: "email",
};


export const VALIDATION_CONSTANTS = { 
  NAME:/^[A-Za-z\d\s]*$/,
  EMAIL: /^(?!.*\.\.)(?!.*\.$)(?!^\.)([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CONTACT_NUMBER: /^\d{10}$/,
  ID: /^[a-zA-Z0-9]*$/,
  CHARACTER: /^[a-zA-Z\s]*$/,
  NUMERIC: /^\d+$/,
    // Add more text as needed
  };
   